import { Link } from "react-router-dom";
import { SearchPageShell } from "@/pages/search/SearchDocLayout";
import { usePortfolioProjects } from "@/lib/portfolioCms";
import { PORTFOLIO_PROJECTS } from "@/data/portfolioProjects";
import { openContactForm } from "@/lib/contactForm";

export default function PortfolioHubPage() {
  const { items, loading } = usePortfolioProjects();
  const list = (items && items.length ? items : PORTFOLIO_PROJECTS).filter((row) => row?.slug);
  const featured = list[0] || null;
  const rest = featured ? list.slice(1) : list;

  return (
    <SearchPageShell testId="portfolio-hub" wide flush>
      <section className="ds-guide-hero" aria-labelledby="portfolio-hero-title">
        <p className="ds-search-kicker">PORTFOLIO</p>
        <h1 id="portfolio-hero-title" className="ds-search-h1">공개 작업 사례</h1>
        <p className="ds-search-summary">
          관리자 CMS에서 공개된 프로젝트만 이 목록에 나타납니다. 각 상세 페이지가 검색·인용 근거입니다.
        </p>
        <div className="ds-guide-hero__actions">
          <Link className="ds-guide-ghost" to="/services">서비스</Link>
          <Link className="ds-guide-ghost" to="/guides">가이드</Link>
        </div>
      </section>
      {loading && !featured ? <p>불러오는 중</p> : null}
      {featured ? (
        <article className="ds-guide-featured">
          <Link className="ds-guide-featured__link" to={featured.path || `/portfolio/${featured.slug}`}>
            <p className="ds-search-kicker">{featured.tag}</p>
            <p className="ds-guide-featured__label">Work</p>
            <h2>{featured.title}</h2>
            <p>{featured.shortDescription}</p>
            <span className="ds-guide-more">사례 보기 →</span>
          </Link>
        </article>
      ) : null}
      <div className="ds-search-grid ds-guide-grid">
        {rest.map((item) => (
          <Link key={item.slug} className="ds-search-card" to={item.path || `/portfolio/${item.slug}`}>
            <p className="ds-search-kicker">{item.tag}</p>
            <h2>{item.title}</h2>
            <p>{item.shortDescription}</p>
            <span className="ds-guide-more">사례 보기 →</span>
          </Link>
        ))}
      </div>
      <section className="ds-guide-cta-band">
        <h2>프로젝트 상담</h2>
        <a className="ds-search-cta" href="/#contact" onClick={(e) => { e.preventDefault(); openContactForm(); }}>
          상담 신청
        </a>
      </section>
    </SearchPageShell>
  );
}
